import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAcc, useAuth, useOTP } from '../../hooks';
import AccountSelectionPage from '../../pages/AccountSelectionPage';
import AgreementPage from '../../pages/AgreementPage';
import HomePage from '../../pages/HomePage';
import LoginPage from '../../pages/LoginPage';
import OtpVerifyPage from '../../pages/OtpVerifyPage';
import { useLazyGetProfileQuery } from '../../services/users_v1';

function PrivateOutlet() {
    const auth = useAuth();
    const acc = useAcc();
    const otp = useOTP();

    const [fetchProfile, { data: profile }] = useLazyGetProfileQuery(undefined);

    useEffect(() => {
        if (auth.user) {
            fetchProfile(undefined);
        }
    }, [auth.user]);

    return auth?.user ? (
        (otp.otp_enabled && otp.otp_configured === false) ?
            <OtpVerifyPage /> :
            (auth?.account ?
                (
                    acc.agr_offer !== null ?
                        <Outlet /> :
                        <AgreementPage />
                ) : (
                    profile?.results.pd_agreement === true ?
                        <AccountSelectionPage />
                        :
                        <AgreementPage />
                )
            )
    ) : (
        location.pathname === '/' ? <HomePage /> : <LoginPage />
    )
}

export default PrivateOutlet;
